import { ROLES } from "constants/Constants";
import { useCookies } from "react-cookie";
import OrganisationCordinator from "./OrganisationCordinator";
import ProgramCordinator from "./ProgramCordinator";
import CourseParticipant from "./CourseParticipant";
import { Checkbox, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { dashboardMetrics, getConfigOrganization } from "ServerAPI/serverAPI";
import { Col, Row } from "react-bootstrap";
// import organisationCord from "../../../assets/images/Coordinator illustration.svg";
import commonheadIcon from "../../../assets/images/common-header-icon.svg";
import { TrendingUp, ArrowRight } from "lucide-react";
import { FEATURES, useFeaturePermissions } from "constants/FeaturePermissions";

const UserLandingPage = () => {
  const [cookies] = useCookies();
  const { hasFeature } = useFeaturePermissions();
  const [metricsDetails, setMetricsDetails] = useState({});
  const [allMetricsDetails, setAllMetricsDetails] = useState({});
  const [departments, setDepartments] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [departmentValues, setDepartmentValues] = useState([]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchDashboardMetrics = async () => {
    const metrics = await dashboardMetrics(
      cookies?.email,
      cookies?.roleId,
      cookies?.organizationId,
      cookies.department
    );
    if (metrics.status === 200) {
      setMetricsDetails(metrics?.data);
      setAllMetricsDetails(metrics?.data);
    }
  };
  const fetchOrganisationDetails = async () => {
    const details = await getConfigOrganization(
      cookies?.email,
      cookies?.organizationId,
      cookies.userId
    );
    if (details?.status === 200) {
      const allDepartment = details.data.department.map((department) => {
        return {
          value: department,
          label: department,
        };
      });
      setDepartmentValues(details.data.department);

      setDepartments(allDepartment);
    }
  };
  const filterMetrics = (keyword) => {
    // if all is un checked clear all checked items
    if (
      departmentValues.length === selectedFilter.length &&
      keyword === "all"
    ) {
      setSelectedFilter([]);
      return;
    }
    // if all is checked , set all items as check
    if (keyword === "all") {
      setSelectedFilter(departmentValues);
      return;
    }
    if (selectedFilter.includes(keyword)) {
      const result = selectedFilter.filter((ele) => {
        return ele !== keyword;
      });

      setSelectedFilter(result);
    } else {
      setSelectedFilter((pre) => {
        return [...pre, keyword];
      });
    }
  };

  // useEffect(() => {
  //   if (cookies.roleId !== UserRole.COURSE_PARTICIPANT) {
  //     fetchDashboardMetrics();
  //     fetchOrganisationDetails();
  //   }
  // }, []);

  useEffect(() => {
    if (selectedFilter.length === 0) {
      setMetricsDetails(allMetricsDetails);
      return;
    }
    const filtredCourseParticipants =
      allMetricsDetails?.courseParticipants?.filter((ele) => {
        return selectedFilter.includes(ele?.department);
      });
    const filtredCourses = allMetricsDetails?.courses?.filter((ele) => {
      return selectedFilter.includes(ele?.courseDepartment);
    });
    const filtredprogramCoordinators =
      allMetricsDetails?.programCoordinators?.filter((ele) => {
        return selectedFilter.includes(ele?.department);
      });

    const filtreduserGroups = allMetricsDetails?.userGroups?.filter((ele) => {
      return selectedFilter.includes(ele?.courseDepartment);
    });

    setMetricsDetails((pre) => {
      return {
        ...pre,
        programCoordinators: filtredprogramCoordinators,
        courses: filtredCourses,
        courseParticipants: filtredCourseParticipants,
        userGroups: filtreduserGroups,
      };
    });
  }, [selectedFilter]);

  return (
    <>
      <div className="">
        <Row className="">
          <Col lg={12} md={12} sm={12} className="p-0">
            <div
              className="justify-content-between align-items-center d-flex px-15 mb-0"
              style={{
                background:
                  "linear-gradient(90.91deg, #2B76FA 1.55%, #022A4E 57.62%)",
                height: "200px",
              }}
            >
              {/* <div>
                <div className="d-flex flex-column g-0">
                  <h1 className="text-white">Welcome {cookies?.name} </h1>
                  <h2 className="text-white mt-2">{cookies?.name} Dashboard</h2>
                </div>
              </div> */}
              <div className="d-flex flex-column g-0">
                <h1 className="text-white">Welcome {cookies?.name} </h1>
              </div>
              <div>
                <img src={commonheadIcon} alt="logo" width={300} height={200} />
              </div>
            </div>
          </Col>
        </Row>
        {/* {cookies.roleId !== "courseParticipant" ? (
          <>
            <Row className="mt-5">
              <Col sm={12} className="d-flex justify-content-end">
                <Tooltip title="Filter By Department">
                  <div onClick={handleClick} className="cursor-pointer">
                    <FilterListIcon />
                  </div>
                </Tooltip>
              </Col>
            </Row>
          </>
        ) : null} */}
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          // onClick={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            sx={{
              padding: 1,
              paddingTop: 0,
              paddingBottom: 0,

              marginTop: 0,
              marginBottom: 0,
            }}
          >
            <Checkbox
              checked={selectedFilter.length == departmentValues.length}
              onClick={() => {
                filterMetrics("all");
              }}
            />
            All
          </MenuItem>
          {departments.map((department, index) => {
            return (
              <>
                <MenuItem
                  key={index}
                  sx={{
                    padding: 1,
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginTop: 0,
                    marginBottom: 0,
                  }}
                >
                  <Checkbox
                    checked={selectedFilter.includes(department?.value)}
                    onClick={() => {
                      filterMetrics(department.value);
                    }}
                  />
                  {department?.value}
                </MenuItem>
              </>
            );
          })}
        </Menu>
        {cookies?.roleId === ROLES.COURSE_PARTICIPANT ? (
          <>
            <CourseParticipant />
          </>
        ) : null}
        {hasFeature(FEATURES.PROGRESS_TRACKING) ? (
          <div className="px-8 mt-5">
            {cookies?.roleId === ROLES.PROGRAM_COORDINATOR ? (
              <>
                <ProgramCordinator
                  metricsDetails={metricsDetails}
                  allMetricsDetails={allMetricsDetails}
                  departments={departments}
                  filterMetrics={filterMetrics}
                />
              </>
            ) : null}
            {cookies?.roleId === ROLES.ORGANIZATION_COORDINATOR ? (
              <>
                <OrganisationCordinator
                  metricsDetails={metricsDetails}
                  allMetricsDetails={allMetricsDetails}
                  departments={departments}
                  filterMetrics={filterMetrics}
                />
              </>
            ) : null}
          </div>
        ) : (
          cookies?.roleId !== ROLES.COURSE_PARTICIPANT && (
            <>
              {/* Welcome Banner */}
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    background: "#f5f5f5", // Light gray background
                    borderRadius: "0px", // No rounded borders
                    color: "#000000", // Black text
                    padding: "48px 32px",
                  }}
                >
                  <div style={{ marginBottom: "16px" }}>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        background: "#e0e0e0",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <TrendingUp size={40} color="#333" />
                    </div>
                  </div>
                  <h3
                    style={{
                      fontWeight: "600",
                      marginBottom: "16px",
                      fontSize: "24px",
                    }}
                  >
                    Welcome to Your Company Training Platform
                  </h3>
                  <p
                    style={{
                      fontSize: "16px",
                      opacity: "0.85",
                      marginBottom: "24px",
                      maxWidth: "500px",
                      margin: "0 auto 24px",
                    }}
                  >
                    Access tailored resources, track your progress, and grow
                    your skills with our interactive training modules. We're
                    excited to support your learning journey.
                  </p>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};

export default UserLandingPage;
